// Admin user management. UI-host endpoints — only callable by role=admin.

import { api } from "./client";
import type { Role } from "./auth";

export interface AdminUserRow {
  id: number;
  username: string;
  role: Role;
  created_at: string;
}

export interface CreateUserRequest {
  username: string;
  initial_password: string;
}

export const adminApi = {
  listUsers: () => api<AdminUserRow[]>("/api/admin/users"),
  createUser: (body: CreateUserRequest) =>
    api<AdminUserRow>("/api/admin/users", { method: "POST", body }),
  deleteUser: (id: number) =>
    api<{ ok: boolean }>(`/api/admin/users/${id}`, { method: "DELETE" }),
  resetPassword: (id: number, new_password: string) =>
    api<{ ok: boolean }>(`/api/admin/users/${id}/password`, {
      method: "POST",
      body: { new_password },
    }),
};
